export const AspectsStatsMock = {
  items: [
    {
      aspect: "Taste",
      avg: 9.419354838709678,
      bayesian_avg: 9.34920634920635,
      count: 62,
      median: 10,
      negative: 2,
      neutral: 1,
      positive: 59,
      ts_updated: 1744936613.2386816,
    },
    {
      aspect: "Product Effectiveness",
      avg: 7.666666666666667,
      bayesian_avg: 7.56,
      count: 24,
      median: 8.5,
      negative: 3,
      neutral: 3,
      positive: 18,
      ts_updated: 1744936621.9647787,
    },
    {
      aspect: "Convenience",
      avg: 9.444444444444445,
      bayesian_avg: 9.210526315789474,
      count: 18,
      median: 10,
      negative: 0,
      neutral: 0,
      positive: 18,
      ts_updated: 1744936622.3130186,
    },
    {
      aspect: "Texture",
      avg: 8.6,
      bayesian_avg: 8.375,
      count: 15,
      median: 9,
      negative: 1,
      neutral: 1,
      positive: 13,
      ts_updated: 1744936611.8466496,
    },
    {
      aspect: "Value For Money",
      avg: 6.083333333333333,
      bayesian_avg: 6,
      count: 12,
      median: 7,
      negative: 3,
      neutral: 3,
      positive: 6,
      ts_updated: 1744936612.1943705,
    },
    {
      aspect: "Value For Money2",
      avg: 6.083333333333333,
      bayesian_avg: 6,
      count: 12,
      median: 7,
      negative: 3,
      neutral: 3,
      positive: 6,
      ts_updated: 1744936612.1943705,
    },
    {
      aspect: "Value For Money3",
      avg: 6.083333333333333,
      bayesian_avg: 6,
      count: 12,
      median: 7,
      negative: 3,
      neutral: 3,
      positive: 6,
      ts_updated: 1744936612.1943705,
    },
    {
      aspect: "Value For Money4",
      avg: 6.083333333333333,
      bayesian_avg: 6,
      count: 12,
      median: 7,
      negative: 3,
      neutral: 3,
      positive: 6,
      ts_updated: 1744936612.1943705,
    },
    {
      aspect: "Value For Money5",
      avg: 6.083333333333333,
      bayesian_avg: 6,
      count: 12,
      median: 7,
      negative: 3,
      neutral: 3,
      positive: 6,
      ts_updated: 1744936612.1943705,
    },
    {
      aspect: "Value For Money6",
      avg: 6.083333333333333,
      bayesian_avg: 6,
      count: 12,
      median: 7,
      negative: 3,
      neutral: 3,
      positive: 6,
      ts_updated: 1744936612.1943705,
    },
  ],
};

export const AspectsStatsCompareMock = {
  items: [
    {
      aspect: "Taste",
      avg: 8.512345678901234,
      bayesian_avg: 8.41234567890123,
      count: 58,
      median: 9,
      negative: 3,
      neutral: 2,
      positive: 53,
      ts_updated: 1744936613.2386816,
    },
    {
      aspect: "Product Effectiveness",
      avg: 7.123456789012346,
      bayesian_avg: 7.23456789012345,
      count: 20,
      median: 8.0,
      negative: 2,
      neutral: 2,
      positive: 16,
      ts_updated: 1744936621.9647787,
    },
    {
      aspect: "Convenience",
      avg: 8.123456789012346,
      bayesian_avg: 8.87654321098765,
      count: 15,
      median: 9,
      negative: 1,
      neutral: 1,
      positive: 13,
      ts_updated: 1744936622.3130186,
    },
    {
      aspect: "Texture",
      avg: 7.654321098765432,
      bayesian_avg: 7.54321098765432,
      count: 13,
      median: 8,
      negative: 2,
      neutral: 2,
      positive: 9,
      ts_updated: 1744936611.8466496,
    },
    {
      aspect: "Value For Money",
      avg: 5.987654321098765,
      bayesian_avg: 5.87654321098765,
      count: 10,
      median: 8,
      negative: 2,
      neutral: 2,
      positive: 6,
      ts_updated: 1744936612.1943705,
    },
    {
      aspect: "Value For Money2",
      avg: 5.123456789012346,
      bayesian_avg: 5.23456789012345,
      count: 11,
      median: 6,
      negative: 2,
      neutral: 2,
      positive: 7,
      ts_updated: 1744936612.1943705,
    },
    {
      aspect: "Value For Money3",
      avg: 6.654321098765432,
      bayesian_avg: 6.54321098765432,
      count: 13,
      median: 7,
      negative: 1,
      neutral: 2,
      positive: 10,
      ts_updated: 1744936612.1943705,
    },
    {
      aspect: "Value For Money4",
      avg: 7.234567890123457,
      bayesian_avg: 7.12345678901235,
      count: 14,
      median: 8,
      negative: 2,
      neutral: 1,
      positive: 11,
      ts_updated: 1744936612.1943705,
    },
    {
      aspect: "Value For Money5",
      avg: 5.876543210987654,
      bayesian_avg: 5.76543210987654,
      count: 12,
      median: 7,
      negative: 3,
      neutral: 2,
      positive: 7,
      ts_updated: 1744936612.1943705,
    },
    {
      aspect: "Value For Money6",
      avg: 6.345678901234568,
      bayesian_avg: 6.23456789012345,
      count: 12,
      median: 7,
      negative: 2,
      neutral: 2,
      positive: 8,
      ts_updated: 1744936612.1943705,
    },
  ],
};

export const AspectReviewsMock = {
  items: [
    {
      review_id: "Taste",
      phrases: [
        "Some customers report the taste as too sweet, artificial, or slightly medicinal. If the flavor is unpleasant or overpowering, users may stop taking the gummies consistently, impacting perceived results.",
      ],
      score: 0.2,
      ts_updated: 0,
    },
    {
      review_id: "Product Effectiveness",
      phrases: ["string", "string", "string"],
      score: 0.3,
      ts_updated: 0,
    },
    {
      review_id: "Convenience",
      phrases: ["string", "string", "string"],
      score: 0.2,
      ts_updated: 0,
    },
    {
      review_id: "Texture",
      phrases: ["string", "string", "string"],
      score: 0.4,
      ts_updated: 0,
    },
    {
      review_id: "Value For Money",
      phrases: ["string", "string", "string"],
      score: 0.5,
      ts_updated: 0,
    },
    {
      review_id: "Value For Money1",
      phrases: ["string", "string", "string"],
      score: 0.5,
      ts_updated: 0,
    },
    {
      review_id: "Value For Money2",
      phrases: ["string", "string", "string"],
      score: 0.5,
      ts_updated: 0,
    },
    {
      review_id: "Value For Money3",
      phrases: ["string", "string", "string"],
      score: 0.5,
      ts_updated: 0,
    },
    {
      review_id: "Value For Money4",
      phrases: ["string", "string", "string"],
      score: 0.5,
      ts_updated: 0,
    },
    {
      review_id: "Value For Money5",
      phrases: ["string", "string", "string"],
      score: 0.5,
      ts_updated: 0,
    },
  ],
};

export const AspectImproveMock = [
  {
    steps: [
      "Conduct flavor testing to identify the most preferred taste profiles.",
      "Use natural fruit flavors and reduce artificial aftertaste.",
      "Offer multiple flavor options to cater to different preferences.",
    ],
    improvementValue: "+$2,070.59",
    score: 0.3,
  },
  {
    steps: [
      "Conduct flavor testing to identify the most preferred taste profiles.",
      "Use natural fruit flavors and reduce artificial aftertaste.",
      "Offer multiple flavor options to cater to different preferences.",
    ],
    improvementValue: "+$2,070.59",
    score: 0.4,
  },
  {
    steps: [
      "Conduct flavor testing to identify the most preferred taste profiles.",
      "Use natural fruit flavors and reduce artificial aftertaste.",
      "Offer multiple flavor options to cater to different preferences.",
    ],
    improvementValue: "+$2,070.59",
    score: 0.5,
  },
  {
    steps: [
      "Conduct flavor testing to identify the most preferred taste profiles.",
      "Use natural fruit flavors and reduce artificial aftertaste.",
      "Offer multiple flavor options to cater to different preferences.",
    ],
    improvementValue: "+$2,070.59",
    score: 0.1,
  },
  {
    steps: [
      "Conduct flavor testing to identify the most preferred taste profiles.",
      "Use natural fruit flavors and reduce artificial aftertaste.",
      "Offer multiple flavor options to cater to different preferences.",
    ],
    improvementValue: "+$2,070.59",
    score: 0.2,
  },
  {
    steps: [
      "Conduct flavor testing to identify the most preferred taste profiles.",
      "Use natural fruit flavors and reduce artificial aftertaste.",
      "Offer multiple flavor options to cater to different preferences.",
    ],
    improvementValue: "+$2,070.59",
    score: 0.3,
  },
  {
    steps: [
      "Conduct flavor testing to identify the most preferred taste profiles.",
      "Use natural fruit flavors and reduce artificial aftertaste.",
      "Offer multiple flavor options to cater to different preferences.",
    ],
    improvementValue: "+$2,070.59",
    score: 0.6,
  },
  {
    steps: [
      "Conduct flavor testing to identify the most preferred taste profiles.",
      "Use natural fruit flavors and reduce artificial aftertaste.",
      "Offer multiple flavor options to cater to different preferences.",
    ],
    improvementValue: "+$2,070.59",
    score: 0.5,
  },
  {
    steps: [
      "Conduct flavor testing to identify the most preferred taste profiles.",
      "Use natural fruit flavors and reduce artificial aftertaste.",
      "Offer multiple flavor options to cater to different preferences.",
    ],
    improvementValue: "+$2,070.59",
    score: 0.3,
  },
  {
    steps: [
      "Conduct flavor testing to identify the most preferred taste profiles.",
      "Use natural fruit flavors and reduce artificial aftertaste.",
      "Offer multiple flavor options to cater to different preferences.",
    ],
    improvementValue: "+$2,070.59",
    score: 0.1,
  },
];

enum ReviewColors {
  TotalReviews = "#5295E0",
  Medium = "#C8A857",
  Negative = "#FE5858",
  Neutral = "#fff",
  Positive = "#80C67A",
}

const ReviewStyles = {
  TotalReviews: {
    color: ReviewColors.TotalReviews,
    backgroundColor: "rgba(82, 149, 224, 0.1)",
  },
  Medium: {
    color: ReviewColors.Medium,
    backgroundColor: "rgba(200, 168, 87, 0.1)",
  },
  Negative: {
    color: ReviewColors.Negative,
    backgroundColor: "rgba(254, 88, 88, 0.1)",
  },
  Neutral: {
    color: ReviewColors.Neutral,
    backgroundColor: "rgba(108, 117, 125, 0.1)",
  },
  Positive: {
    color: ReviewColors.Positive,
    backgroundColor: "rgba(128, 198, 122, 0.1)",
  },
};

export const ProductProblemsMock = {
  items: [
    {
      title: "Lack of essential parts or accessories",
      problems: [
        { name: "Total Reviews", value: 2, ...ReviewStyles.TotalReviews },
        { name: "Medium", value: 0, ...ReviewStyles.Medium },
        { name: "Negative", value: 2, ...ReviewStyles.Negative },
        { name: "Neutral", value: 0, ...ReviewStyles.Neutral },
        { name: "Positive", value: 0, ...ReviewStyles.Positive },
      ],
      solution:
        "Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at. Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at.",
    },
    {
      title: "Lack of essential parts or accessories2",
      problems: [
        { name: "Total Reviews", value: 2, ...ReviewStyles.TotalReviews },
        { name: "Medium", value: 0, ...ReviewStyles.Medium },
        { name: "Negative", value: 2, ...ReviewStyles.Negative },
        { name: "Neutral", value: 0, ...ReviewStyles.Neutral },
        { name: "Positive", value: 0, ...ReviewStyles.Positive },
      ],
      solution:
        "1Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at. Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at.",
    },
    {
      title: "Lack of essential parts or accessories3",
      problems: [
        { name: "Total Reviews", value: 2, ...ReviewStyles.TotalReviews },
        { name: "Medium", value: 0, ...ReviewStyles.Medium },
        { name: "Negative", value: 2, ...ReviewStyles.Negative },
        { name: "Neutral", value: 0, ...ReviewStyles.Neutral },
        { name: "Positive", value: 0, ...ReviewStyles.Positive },
      ],
      solution:
        "2Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at. Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at.",
    },
    {
      title: "Lack of essential parts or accessories4",
      problems: [
        { name: "Total Reviews", value: 2, ...ReviewStyles.TotalReviews },
        { name: "Medium", value: 0, ...ReviewStyles.Medium },
        { name: "Negative", value: 2, ...ReviewStyles.Negative },
        { name: "Neutral", value: 0, ...ReviewStyles.Neutral },
        { name: "Positive", value: 0, ...ReviewStyles.Positive },
      ],
      solution:
        "3Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at. Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at.",
    },
    {
      title: "Lack of essential parts or accessories5",
      problems: [
        { name: "Total Reviews", value: 2, ...ReviewStyles.TotalReviews },
        { name: "Medium", value: 0, ...ReviewStyles.Medium },
        { name: "Negative", value: 2, ...ReviewStyles.Negative },
        { name: "Neutral", value: 0, ...ReviewStyles.Neutral },
        { name: "Positive", value: 0, ...ReviewStyles.Positive },
      ],
      solution:
        "4Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at. Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at.",
    },
    {
      title: "Lack of essential parts or accessories6",
      problems: [
        { name: "Total Reviews", value: 2, ...ReviewStyles.TotalReviews },
        { name: "Medium", value: 0, ...ReviewStyles.Medium },
        { name: "Negative", value: 2, ...ReviewStyles.Negative },
        { name: "Neutral", value: 0, ...ReviewStyles.Neutral },
        { name: "Positive", value: 0, ...ReviewStyles.Positive },
      ],
      solution:
        "5Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at. Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at.",
    },
    {
      title: "Lack of essential parts or accessories7",
      problems: [
        { name: "Total Reviews", value: 2, ...ReviewStyles.TotalReviews },
        { name: "Medium", value: 0, ...ReviewStyles.Medium },
        { name: "Negative", value: 2, ...ReviewStyles.Negative },
        { name: "Neutral", value: 0, ...ReviewStyles.Neutral },
        { name: "Positive", value: 0, ...ReviewStyles.Positive },
      ],
      solution:
        "6Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at. Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at.",
    },
    {
      title: "Lack of essential parts or accessories8",
      problems: [
        { name: "Total Reviews", value: 2, ...ReviewStyles.TotalReviews },
        { name: "Medium", value: 0, ...ReviewStyles.Medium },
        { name: "Negative", value: 2, ...ReviewStyles.Negative },
        { name: "Neutral", value: 0, ...ReviewStyles.Neutral },
        { name: "Positive", value: 0, ...ReviewStyles.Positive },
      ],
      solution:
        "7Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at. Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at.",
    },
    {
      title: "Lack of essential parts or accessories9",
      problems: [
        { name: "Total Reviews", value: 2, ...ReviewStyles.TotalReviews },
        { name: "Medium", value: 0, ...ReviewStyles.Medium },
        { name: "Negative", value: 2, ...ReviewStyles.Negative },
        { name: "Neutral", value: 0, ...ReviewStyles.Neutral },
        { name: "Positive", value: 0, ...ReviewStyles.Positive },
      ],
      solution:
        "8Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at. Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at.",
    },
    {
      title: "Lack of essential parts or accessories10",
      problems: [
        { name: "Total Reviews", value: 2, ...ReviewStyles.TotalReviews },
        { name: "Medium", value: 0, ...ReviewStyles.Medium },
        { name: "Negative", value: 2, ...ReviewStyles.Negative },
        { name: "Neutral", value: 0, ...ReviewStyles.Neutral },
        { name: "Positive", value: 0, ...ReviewStyles.Positive },
      ],
      solution:
        "9Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at. Tortor amet dapibus lectus fermentum. Interdum condimentum tellus tortor enim augue etiam enim massa. Dui sed sollicitudin nunc lorem blandit orci massa orci purus. In platea facilisis commodo rhoncus. Dolor sed feugiat non tellus elementum velit sed at.",
    },
  ],
};
